/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Chair',
  definitions: {
    '24': {
      viewBox: '0 0 24 25',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M10.161.004c.293-.016.724.012.919.318.976 1.533 1.77 4.204 1.791 9.457l.376.079 1.889.418 4.372 1.179c.419.148.683.509.683.932v8.196a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6v-5.025l-4.2 1.983v5.93a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6v-5.893l-1.383-.412-.364 1.78a.6.6 0 1 1-1.171-.266l.378-1.86-4.451-1.329c-.179 1.841-.497 3.86-.995 6.052a.6.6 0 0 1-.718.452.6.6 0 0 1-.452-.718c1.128-4.963 1.308-8.985 1.048-12.008-.164-1.913-.427-4.342-1.566-5.974a.6.6 0 0 1 .148-.835C5.199 1.67 6.626 1.008 7.847.574 8.459.356 9.034.19 9.507.094a4.7 4.7 0 0 1 .654-.091zm-3.42 13.541l-.041.724 6.892 2.057v-.726l-6.851-2.055zm8.05 2.019v.649l4.2-1.983v-.63l-4.2 1.964zM12.22 10.87c-.109-.023-.37-.01-.803.096-.408.1-.893.263-1.404.466a20.41 20.41 0 0 0-2.387 1.135l6.556 1.957 4.471-2.09c-1.057-.335-2.512-.695-3.785-.988l-1.87-.413-.777-.162zm-.597-3.02a6.63 6.63 0 0 0-.737.173c-.466.134-1.011.323-1.569.542-.988.387-1.968.847-2.592 1.225a31.46 31.46 0 0 1 .062 1.877c.888-.524 1.827-.971 2.785-1.351.54-.214 1.081-.398 1.56-.516.177-.043.36-.078.54-.104a43.93 43.93 0 0 0-.048-1.847zM10.21 1.203a3.65 3.65 0 0 0-.466.068c-.403.082-.921.229-1.496.434-.986.351-2.096.854-3.035 1.437.584 1.135 1.126 2.932 1.396 5.336.663-.354 1.482-.722 2.27-1.031.583-.228 1.165-.432 1.676-.578.349-.1.694-.181.992-.221-.237-2.832-.773-4.454-1.337-5.445z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
